<script lang="ts" setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { oidcClient } from '@/services/oidcClient';
import { appRoutes } from '@/router/router';

const router = useRouter();

onBeforeMount(() => {
  oidcClient.events.addUserLoaded((user) => {
    if (user?.access_token) {
      router.push(appRoutes.mainPage.path);
    }
  });
});
</script>

<template>
  <router-view />
</template>

<style scoped></style>
